import { ENOSI_USER_AUTH_REGISTER_CONFIRM } from 'src/util/constants';
import { fetchREST } from 'src/util/environment';
// import { commitMutation, graphql } from 'react-relay';

// const mutation = graphql`
//   mutation RegisterConfirmMutationMutation(
//     $email: String!
//     $password: String!
//     $verificationCode: String!
//   ) {
//     passwordResetConfirm(
//       email: $email
//       password: $password
//       verificationCode: $verificationCode
//     )
//   }
// `;

const RegisterConfirmMutation = (req, onCompleted, onError) => {
  const { email, password, verificationCode } = req;
  const variables = { email, password, verificationCode };

  // TODO: until we have a unauthenticated endpoint for auth
  // commitMutation(environment, {
  //   mutation,
  //   variables,
  //   onCompleted,
  //   onError,
  // });

  fetchREST(
    ENOSI_USER_AUTH_REGISTER_CONFIRM,
    JSON.stringify(variables),
    onCompleted,
    onError,
  );
};

export default RegisterConfirmMutation;
